/* global axios */
import ApiClient from './ApiClient';

class ScheduledBroadcastsAPI extends ApiClient {
  constructor() {
    super('scheduled_broadcasts', { accountScoped: true });
  }

  /**
   * Get all scheduled broadcasts for the current account
   * @returns {Promise}
   */
  getScheduledBroadcasts(page = 1, pageSize = 25) {
    return axios.get(this.url, {
      params: {
        page,
        per_page: pageSize,
      },
    });
  }

  /**
   * Create a new scheduled broadcast
   * @param {Object} broadcastData
   * @returns {Promise}
   */
  createScheduledBroadcast(broadcastData) {
    return axios.post(this.url, {
      scheduled_broadcast: broadcastData,
    });
  }

  /**
   * Update an existing scheduled broadcast
   * @param {Number} id
   * @param {Object} broadcastData
   * @returns {Promise}
   */
  updateScheduledBroadcast(id, broadcastData) {
    return axios.put(`${this.url}/${id}`, {
      scheduled_broadcast: broadcastData,
    });
  }

  /**
   * Cancel/Delete a scheduled broadcast
   * @param {Number} id
   * @returns {Promise}
   */
  cancelScheduledBroadcast(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  /**
   * Get a single scheduled broadcast
   * @param {Number} id
   * @returns {Promise}
   */
  getScheduledBroadcast(id) {
    return axios.get(`${this.url}/${id}`);
  }
}

export default new ScheduledBroadcastsAPI();
